import {useCallback} from "react";
import buildCarouselCards from "../utils/buildCarouselCards";

/**
 * Hook para construir payloads de plantillas Gupshup.
 * Permite generar payloads de tipo TEXT, MEDIA, LOCATION, AUTHENTICATION o CAROUSEL.
 */
export const useBuildPayload = ({
                                    category,
                                    templateName,
                                    language,
                                    body,
                                    bodyPreview,
                                    footer,
                                    headerType,
                                    headerText,
                                    headerTextVariable,
                                    headerMedia,
                                    labels,
                                    addSecurityRecommendation,
                                    addExpirationTime,
                                    codeExpirationMinutes,
                                    gupshup_app_id,
                                    headerTextResolved,
                                    headerTypeToTemplateType,
                                    fileToExampleMediaString,
                                    buildButtons,
                                    lat,
                                    lng,
                                    locName,
                                    locAddress,
                                    carouselCards = [],
                                    buttonTypes = [],
                                    templateType,
                                }) => {
    /**
     * Función principal que construye el payload en base a las props actuales.
     */
    console.log("category", category?.toUpperCase())
    //console.log("templateName",templateName)
    //console.log("language",language)
    console.log("body", body)
    //console.log("bodyPreview",bodyPreview)
    //console.log("footer",footer)
    console.log("headerType",headerType)
    //console.log("headerText",headerText)
    //console.log("headerTextVariable",headerTextVariable)
    console.log("headerMedia",headerMedia)
    //console.log("labels",labels)
    //console.log("addSecurityRecommendation",addSecurityRecommendation)
    //console.log("addExpirationTime",addExpirationTime)
    //console.log("codeExpirationMinutes",codeExpirationMinutes)
    //console.log("gupshup_app_id",gupshup_app_id)
    //console.log("headerTextResolved",headerTextResolved)
    console.log("headerTypeToTemplateType",headerTypeToTemplateType)
    //console.log("fileToExampleMediaString",fileToExampleMediaString)
    //console.log("buildButtons",buildButtons)
    //console.log("lat",lat)
    //console.log("lng",lng)
    //console.log("locName",locName)
    //console.log("locAddress",locAddress)
    console.log("carouselCards", carouselCards)
    console.log("templateType", `-${templateType?.toUpperCase()}-`)
    const isAuth = category?.toUpperCase() === "AUTHENTICATION";
    const isCarousel = templateType?.toUpperCase() === "CAROUSEL";
    const buildPayload = useCallback(async () => {

        // 🔐 Rama especial AUTH
        if (isAuth) {
            let authContent = body || "{{1}} is your verification code.";
            if (addSecurityRecommendation) {
                authContent += " For your security, do not share this code.";
            }

            return {
                elementName: templateName,
                languageCode: langToCode(language),
                content: authContent,
                category: "AUTHENTICATION",
                appId: gupshup_app_id,
                vertical: labels?.trim() || "otp",
                templateType: "TEXT",
                example: bodyPreview || "123456 is your verification code.",
                exampleHeader: "",
                enableSample: false,
                checkerApprovalRequired: false,
                footer: addExpirationTime
                    ? `This code expires in ${codeExpirationMinutes || 1} minute${
                        Number(codeExpirationMinutes) === 1 ? "" : "s"
                    }`
                    : "",
                buttons: buildButtons(),
                ...(addExpirationTime
                    ? {codeExpirationMinutes: String(codeExpirationMinutes || "0")}
                    : {}),
                addSecurityRecommendation: addSecurityRecommendation ? "true" : "false",
                messageValidity:
                    addExpirationTime && Number(codeExpirationMinutes) > 0
                        ? Number(codeExpirationMinutes) * 60
                        : 600,
            };
        }
        // ✅ Base para las demás categorías
        const baseCommon = {
            elementName: templateName,
            languageCode: langToCode(language),
            category: category?.toUpperCase(),
            vertical: labels?.trim() || "TEXT",
            content: body,
            footer: footer || "",
            example: bodyPreview,
            enableSample: "true",
            allowTemplateCategoryChange: "false",
            appId: gupshup_app_id,
        };
        if (isCarousel) {
            console.log("MARKETING", "CAROUSEL");

            const formattedCards = await buildCarouselCards(
                carouselCards,
                buttonTypes,
                fileToExampleMediaString
            );

            console.log("🎠 Formatted carousel cards:", formattedCards);

            return {
                ...baseCommon,
                category: "MARKETING",
                vertical: "products",
                templateType: "CAROUSEL",
                example: bodyPreview || body,
                cards: JSON.stringify(formattedCards),
            };
        }


        // ─────────────── TEXT
        if (headerType === "text" || headerType === "none") {
            return {
                ...baseCommon,
                templateType: "TEXT",
                header: headerText || "",
                buttons: buildButtons(),
                exampleHeader: headerTextResolved || "",
            };
        }

        // ─────────────── IMAGE / VIDEO / DOCUMENT
        if (["image", "video", "document"].includes(headerType)) {
            const templateType = headerTypeToTemplateType[headerType];
            let exampleMedia = "";
            if (headerMedia) {
                exampleMedia = await fileToExampleMediaString(headerMedia);
            }
            return {
                ...baseCommon,
                templateType,
                buttons: buildButtons(),
                exampleMedia,
            };
        }

        // ─────────────── LOCATION
        if (headerType === "location") {
            return {
                ...baseCommon,
                templateType: "LOCATION",
                buttons: buildButtons(),
                exampleLocation: {
                    latitude: lat,
                    longitude: lng,
                    name: locName || "",
                    address: locAddress || "",
                },
            };
        }
        // ─────────────── Fallback
        return {
            ...baseCommon,
            templateType: "TEXT",
            header: headerText || "",
            buttons: buildButtons(),
            exampleHeader: headerTextVariable || headerText || "",
        };
    }, [
        category,
        templateName,
        language,
        body,
        footer,
        headerType,
        headerText,
        headerTextVariable,
        headerMedia,
        labels,
        addSecurityRecommendation,
        addExpirationTime,
        codeExpirationMinutes,
        gupshup_app_id,
        headerTextResolved,
        headerTypeToTemplateType,
        fileToExampleMediaString,
        buildButtons,
        lat,
        lng,
        locName,
        locAddress,
        carouselCards,
        buttonTypes,
        templateType,
        bodyPreview,
        isAuth,
        isCarousel,
    ]);

    return {buildPayload};
};

// Utilidad local: convertir idioma a código Gupshup
const langToCode = (language) => {
    console.log("language", language)
    const map = {
        en: "en",
        es: "es",
        pt: "pt",
    };
    return map[language] || "en";
};
